/**
 * 
 * CollectionHead Model
 *
 */

import { ApiUtils, BaseAPI } from 'soxo-bootstrap-core';


class CollHead extends BaseAPI {
    constructor() {
        super();

        this.fields = [
            {
                field: 'name',

                caption: 'Name',
            },
        ];
    }

    get id() {
        return 'colhd_id';
    }

    get getEndpoint() {
        return 'CollHeads';
    }

    get path() {
        return `CollHeads`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `CollHeads`;
    }
}


export default CollHead;
